import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { refresh } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);
        (async () => {
            try {
                const { data } = await api.get("/auth/google-session", {
                    headers: { "X-Session-ID": sessionId },
                });
                if (data.access_token) {
                    const { setToken } = await import("@/lib/api");
                    setToken(data.access_token);
                }
                await refresh();
                navigate("/dashboard", { replace: true, state: { user: data } });
            } catch {
                navigate("/login?error=oauth_failed", { replace: true });
            }
        })();
    }, [location, navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-cream-100">
            <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full border-4 border-cream-300 border-t-coral animate-spin"/>
                <p className="text-[14px] text-ink-muted">Signing you in…</p>
            </div>
        </div>
    );
};
